<template>
  <div id="projects" v-if="divVisible">
    <b>プロジェクト情報一覧画面</b><br/><br/>

    <table>
      <tr>
        <td>プロジェクト情報一覧を参照いただきます。</td>
      </tr>
    </table><br/>

    <form onsubmit="return false;">
      <div class="bootstrap-table fixed-table-container" style="margin-bottom:10px;margin-bottom:10px;width: 100%;">
        <table id="rptHeader" class="table table-striped">
          <thead>
            <tr v-for="(head, index) in heads" v-bind:key="'head' + index">
              <td>{{ head.year }}</td>
              <td align="right" width="7%">
                <router-link :to="{ name: 'projectManage', params: { operationType: 'create' } }">
                  <img src="/static/images/add.png" width="19" height="19" />
                </router-link>
              </td>
              <td>
                {{ head.projectInfo.projectName }}
              </td>
              <td>{{ head.leaderMemberName }}</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in rows" v-bind:key="'row' + index">
              <td align="right">{{ row.year }}</td>
              <td align="right">
                <router-link :to="{ name: 'projectManage', params: { operationType: 'modify', projectID: row.projectInfo.projectID } }">
                  <img src="/static/images/icon-edit.png" width="19" height="19" />
                </router-link>
                <router-link :to="{ name: 'projectManage', params: { operationType: 'delete', projectID: row.projectInfo.projectID } }">
                  <img src="/static/images/del.png" width="19" height="19" />
                </router-link>
              </td>
              <td>
                <router-link :to="{ name: 'projectDetails', params: { backScreenId: 'projects', projectID: row.projectInfo.projectID } }">
                  {{ row.projectInfo.projectName }} ({{ row.projectInfo.startDate }} ～ {{ row.projectInfo.endDate }})
                </router-link><br/>
              </td>
              <td>{{ row.leaderMemberName }}</td>
            </tr>
          </tbody>
        </table>
      </div><br/>
      <button @click="$router.push({ name: 'mains', params: { } });" class="btn-mid" style="width:250px;">メイン画面へ</button><br/>
    </form>
  </div>
</template>

<script>
  export default {
    name: "projects",
    data() {
      return {
          divVisible: false,
          user:  { memberID: '', memberName: '', userType: '', deleteFlg: '' },
          heads: [ { year: '', projectInfo:{ projectID: '', projectName: '', startDate: '', endDate: '' }, leaderMemberName: '' } ],
          rows:  [ { year: '', projectInfo:{ projectID: '', projectName: '', startDate: '', endDate: '' }, leaderMemberName: '' } ],
      }
    },
    mounted() {
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.src = '/static/js/common.js?v=17';
      document.body.appendChild(s);
      this.init();
    },
    methods: {
      init: function () {
        var self = this;

        // サーバ側処理呼び出す
        new Promise(function (request, response) {
          var data = self.$route.params;
          common.getAxios().post(process.env.API_URL +"/api/ProjectsInit", data)
            .then(function (res) {
              if (res.data) {
                self.user = res.data.user;
                self.heads = res.data.heads;
                self.rows = res.data.rows;
                self.divVisible = true;
              }
            })
            .catch(function (err) {
              alert(err);
            });
        });

      },
    }

  };
</script>



// WEBPACK FOOTER //
// projects.vue?0a57d382